import { createFileRoute } from '@tanstack/react-router'
import { LedgerScreen } from '../features/ledger'

export const Route = createFileRoute('/ledger')({
  validateSearch: (search: Record<string, unknown>): { invoice?: string; notification?: string; obligation?: string } => ({
    invoice: typeof search.invoice === 'string' && /^[0-9a-f-]{36}$/i.test(search.invoice) ? search.invoice : undefined,
    notification: typeof search.notification === 'string' && /^[0-9a-f-]{36}$/i.test(search.notification) ? search.notification : undefined,
    obligation: typeof search.obligation === 'string' && /^[0-9a-f-]{36}$/i.test(search.obligation) ? search.obligation : undefined,
  }),
  component: function LedgerRoute() {
    const search = Route.useSearch()
    return <LedgerScreen focusInvoice={search.invoice} focusObligation={search.obligation} />
  },
})
